import * as ng from 'angular';

import { ExperienceTypeID, AppDeviceID } from '../';
import { EditorModel, EditorPageModel } from './';
import { UtilsService, propertyParser } from '../../../shared';

import './draggable.directive';

export class EditorController implements ng.IComponentController {
   active:EditorPageModel;
   model:EditorModel;

   static $inject = ['session', 'utils', 'loader'];

   constructor(private session, private utils:UtilsService, private loader) { }

   $onInit() {
      this.loader.showSpinner();
      this.active = this.model.pages[this.model.defaultEditorPageIndex ?? 0];
   }

   $postLink() {
      if (!this.model.hasPages) {
         this.loader.hide();
      }
   }

   hideSpinner() {
      if (this.loader && this.loader.isLoading) {
         this.loader.hide();
      }
   }

   getDefaultImage(imageId:string) {
      let lang = this.model.language;
      let defLang = this.model.campaign.defaultLanguage;
      let uploads = this.model.experience.settings.uploads;
      let typeDef = this.model.typeDef;

      // check the current campaign's default language first
      if ((lang !== defLang) && uploads[imageId] && uploads[imageId][defLang]) {
         return uploads[imageId][defLang];
      }

      // check brand settings starting with current language, then default language
      // then the default for the image id
      let brandUploads = this.session.getBrand().settings.experience.uploads;

      // header image for rsvp, qr, media, email
      if (imageId === 'headerImage') {
         if (typeDef.isWebsite) {
            if (brandUploads.genericHeader) {
               if (brandUploads.genericHeader[lang]) {
                  return brandUploads.genericHeader[lang];
               }

               if (brandUploads.genericHeader[defLang]) {
                  return brandUploads.genericHeader[defLang];
               }
            }
         }

         if (typeDef.id === ExperienceTypeID.Email) {
            if (brandUploads.emailHeader) {
               if (brandUploads.emailHeader[lang]) {
                  return brandUploads.emailHeader[lang];
               }

               if (brandUploads.emailHeader[defLang]) {
                  return brandUploads.emailHeader[defLang];
               }
            }
         }
      }

      // app backgrounds
      if (imageId === 'background' && typeDef.id === ExperienceTypeID.App) {
         let key = typeDef.device === AppDeviceID.Phone ? 'iPhoneBackground' : 'iPadBackground';

         if (brandUploads[key]) {
            if (brandUploads[key][lang]) {
               return brandUploads[key][lang];
            }

            if (brandUploads[key][defLang]) {
               return brandUploads[key][defLang];
            }
         }
      }

      // no default found
      return null;
   }

   setUploadFile(key:string, file:File) {
      let prop = `${key}.${this.model.language}`;
      this.utils.readFileAsDataUrl(file).then(dataUrl => {
         propertyParser(this.model.settings.uploads, prop).set(dataUrl);
      });
   }

   onDeletePage(page:EditorPageModel) {
      if (this.active == page) {
         // update active page since we're about to remove it
         let pageIndex = this.model.pages.indexOf(page);
         if (pageIndex > 0) {
            this.active = this.model.pages[pageIndex - 1];
         } else if (this.model.pages.length > 1) {
            this.active = this.model.pages[pageIndex + 1];
         } else {
            this.active = null; // removing last page
         }
      }

      this.model.deletePage(page);
   }

   drag(page:EditorPageModel) {
      return this.model.pages.indexOf(page);
   }

   drop($event, $data:string, page:EditorPageModel) {
      let dragIndex = parseInt($data);
      let dropIndex = this.model.pages.indexOf(page);
      if (dragIndex != dropIndex) {
         this.model.sortPage(dragIndex, dropIndex);
      }
   }

   setActive(page:EditorPageModel, index:number) {
      this.active = page;
      this.active.layerIndex = index;
   }

   hasDivider(page:EditorPageModel) {
      let pageIndex = this.model.pages.indexOf(page);

      // static pages don't have the add button in front of thumbs
      if (pageIndex == 0 && this.model.hasStaticPages) {
         return false;
      }

      // include divider on first sortable page, not on subsequent
      return pageIndex == 0 || !page.sortable || !this.model.pages[pageIndex-1].sortable;
   }
}

ng.module('e360').component('editor', {
   templateUrl: require('./editor.html'),
   controller: EditorController,
   bindings: {
      model: '<'
   }
});
